export async function registerPlayer({ userId, playerName, token }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/registerPlayer`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token || ""}`,
    },
    body: JSON.stringify({ userId, playerName }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.message || "Failed to register player");
  }
  return data;
}
